import ComplianceClient from "@common/api/ComplianceClient";
import { toggleItemInArray } from "@common/components/helpers/arrays";
import useComplianceView from "./useComplianceView";
import useOrganisationTreeSelections from "@hooks/useOrganisationTreeSelections";

export default function useComplianceSummaryFilters() {
  const { filters, hasSelection, setViewData } = useComplianceView();
  const { selectedEventType, selectedSelfExclusionType, selectedIncidentType } =
    filters;

  const siteIds = useOrganisationTreeSelections("complianceFilters");

  const onEventTypeChange = (id) =>
    onChange(null, {
      name: "selectedEventType",
      value: toggleItemInArray(selectedEventType, id),
    });
  const onIncidentTypeChange = (id) =>
    onChange(null, {
      name: "selectedIncidentType",
      value: toggleItemInArray(selectedIncidentType, id),
    });
  const onSelfExclusionTypeChange = (id) =>
    onChange(null, {
      name: "selectedSelfExclusionType",
      value: toggleItemInArray(selectedSelfExclusionType, id),
    });

  const onAllNamesChange = (_e, { name, value }) =>
    setViewData({ allNames: value });

  const onChange = (_e, { name, value }) =>
    setViewData({ filters: { ...filters, [name]: value } });

  const onPeriodChange = (startDate, endDate) =>
    setViewData({ filters: { ...filters, startDate, endDate } });

  const onPageChange = (_e, { activePage }) =>
    setViewData({ filters: { ...filters, activePage } });

  const getMetaData = () => {
    if (!hasSelection) {
      return;
    }

    ComplianceClient.getMetaData()
      .then((response) => {
        setViewData({ filters: { ...filters, ...response } });
      })
      .finally(() => setViewData({ filtersLoading: false }));
  };

  return {
    ...filters,
    siteIds,
    getMetaData,
    onChange,
    onPageChange,
    onPeriodChange,
    onEventTypeChange,
    onAllNamesChange,
    onIncidentTypeChange,
    onSelfExclusionTypeChange,
  };
}
